import { apiClient } from '../api.client';
import type { FitAnatomyResource } from '../../types/course';
import type { IFitAnatomyService } from '../interfaces/IFitAnatomyService';

export const fitAnatomyReal: IFitAnatomyService = {
  getResources: () =>
    apiClient.get<FitAnatomyResource[]>('/fit-anatomy/resources'),
};
